// API base URL — uses relative URLs on production domain for same-origin cookies
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isProduction = hostname === 'planningsearch.com' || hostname === 'www.planningsearch.com';
export const API_BASE = isProduction ? '' : (process.env.REACT_APP_BACKEND_URL || '');
// Static assets always use the full backend URL (needed before production deploys new files)
export const STATIC_BASE = process.env.REACT_APP_BACKEND_URL || '';
